import { lineString } from '@turf/helpers';
import { useMemo } from 'react';
import { COLOR_BACKGROUND_ACCENT, COLOR_GREEN_700 } from '@alltrails/denali/tokens';
import { LngLat } from '../../types/Geo';
import PolylineSource from './PolylineSource';

type Props = {
  beforeUniqueId?: string;
  coordinates: LngLat[];
  hideArrows?: boolean;
  lineColor?: string;
  lineOutlineColor?: string;
  lineProgress?: number;
  opacity?: number;
  uniqueId?: string;
};

/**
 * Polyline renders a route for the currently selected result
 *
 * Because this is dynamically mounted it will naturally appear on top of pins,
 * which is the desired design. Any selected Marker will naturally appear on top
 * of this Polyline, which is also the desired design.
 *
 * @returns
 */
const Polyline = ({
  beforeUniqueId,
  coordinates,
  hideArrows,
  lineColor = COLOR_BACKGROUND_ACCENT,
  lineOutlineColor = COLOR_GREEN_700,
  lineProgress = 1,
  opacity,
  uniqueId
}: Props) => {
  // lineString requires multiple points, otherwise it throws an error
  const data = useMemo(() => {
    if (coordinates.length > 1) {
      return lineString(coordinates);
    }
    return null;
  }, [coordinates]);

  return data ? (
    <PolylineSource
      beforeUniqueId={beforeUniqueId}
      data={data}
      hideArrows={hideArrows}
      lineColor={lineColor}
      lineOutlineColor={lineOutlineColor}
      lineProgress={lineProgress}
      opacity={opacity}
      uniqueId={uniqueId}
    />
  ) : null;
};

export default Polyline;
